import { RootState } from "model/Redux";
import IUserTournament from "model/UserTournament/IUserTournament";
import { Selector } from "reselect";

const userTournamentSelector: Selector<RootState, IUserTournament[]> = (state) => state.userTournament.data;
export const userTournamentLoadingSelector: Selector<RootState, Boolean> = (state) => state.userTournament.loading;

export default userTournamentSelector;